<template>
	<div class="gov_headerbox" :style="isCollapse?'left: 0;width: 100%;':''">
		<div class="gov_header" :style="isCollapse?'left: 0;width: 92%;':''">
			<span class="screen" @click="onClickfoldBtn" style="z-index: 1999;" v-show="isCollapse"><i
					class="el-icon-s-unfold"></i>菜单栏</span>
			<div class="fl foldBtn" @click="onClickfoldBtn" :title="isCollapse?'展开菜单':'折叠菜单'" v-show="isCollapse"><i class="foldBtn-icon" :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i></div>
			<div class="oh">
				<div class="fl lh48 ml-2" >
				<span class="px-1 cur-pointer content-us" @click="routerblank('/order')">产业研究大脑 39800元/年，立即订购 ></span>
				<a class="dib ml-2 cur-pointer content-us" href="https://chanyeyanjiu.cn/#/user-login#login-service" target="_balnk" >三种服务方式(账号/API/定制) ></a>
				<a class="dib ml-2 cur-pointer content-us" href="https://cyyj.ocn.com.cn/file/中投顾问产业研究大脑介绍-2024版.pdf" download>产品手册 ></a>
				<span class="dib ml-2  cur-pointer content-us"  @click="isShowShiyong = true">试用申请 ></span>
				<span class="dib ml-2  cur-pointer content-us"  @click="yjLoginPage('https://chanyeyanjiu.cn/#/user-login')">正式版登陆 ></span>
			</div>
			<div class="fr lh48 ml-1 pr-2" >
				<span class="dib ml-2 cur-pointer"  @click="yjLoginPage('https://www.zhaoshangdanao.com/')">招商大脑 ></span>
				<span class="dib ml-2 cur-pointer"  @click="yjLoginPage('https://www.chanyetouzi.com')">投资大脑 ></span>
				<span class="dib ml-2 cur-pointer"  @click="yjLoginPage('https://www.ocn.com.cn/')">中投顾问</span>
			</div>
			</div>
			

			<!-- 时间宽度+i 82+14 一条列表142   --> 
			<!-- <video-teaching v-if="showVideo" :type="videoType" seat="top" style="line-height: 48px;"></video-teaching> -->
			<el-dialog class="localChain"  :modal-append-to-body="false" append-to-body title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>                                      
			</el-dialog>
		</div>
		<el-dialog class="localChain" :modal-append-to-body="false" append-to-body title=""
				:visible.sync="isShowShiyong" width="650px" top="15vh">
				<shiyong @handerChrend="handerChrend"></shiyong>
			</el-dialog>
	</div>
</template>

<script>
	import $ from "jquery";
	import { mapState, mapMutations, mapGetters } from "vuex";
	import shiyong from "@/components/inc/shiyong.vue"

	export default {
		name: 'govheader',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		isSmsLogin: (state) => state.isSmsLogin,
		}),
		...mapGetters(['isCollapse'])
		},
		components: {
			shiyong
		},
		data() {
			return {
				isShowFreeUserTips:false,
				isShowShiyong:false,
				//usern.edition 判断是否为普通或完整版本  user.groupType 判断为试用账户还是全开用户 
				isopen: false,
				islogin: false,
				ischange: false,
				timerClock: null,
				timeClockBtn: true,
				dynamicMovepostion: 0,
				userdata: {
					currentCity: {
						text: ""
					},
					operatList: {
						mkczsm: false
					},
					token: ""
				},
				userdat: {},
				crmuserdata: {},
				dynamicListnum: [],
				dynamicWidth: 0,
				curWebsite: this.$api.getWebsiteType(),
				testDynamic: [{
						"id": 23362,
						"date": "2023-08-14",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 13,
						"isRead": 0
					},
					{
						"id": 23360,
						"date": "2023-08-14",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 37,
						"isRead": 0
					},
					{
						"id": 23394,
						"date": "2023-08-14",
						"type": 5,
						"typeText": "企业资讯",
						"num": 6,
						"isRead": 0
					},
					{
						"id": 23395,
						"date": "2023-08-13",
						"type": 5,
						"typeText": "企业资讯",
						"num": 12,
						"isRead": 0
					},
					{
						"id": 23361,
						"date": "2023-08-12",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 3,
						"isRead": 0
					},
					{
						"id": 23349,
						"date": "2023-08-11",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 17,
						"isRead": 0
					},
					{
						"id": 23350,
						"date": "2023-08-11",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 55,
						"isRead": 0
					},
					{
						"id": 23351,
						"date": "2023-08-11",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 1,
						"isRead": 0
					},
					{
						"id": 23352,
						"date": "2023-08-10",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 11,
						"isRead": 0
					},
					{
						"id": 23353,
						"date": "2023-08-10",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 110,
						"isRead": 0
					},
					{
						"id": 23354,
						"date": "2023-08-10",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 4,
						"isRead": 0
					},
					{
						"id": 23355,
						"date": "2023-08-10",
						"type": 5,
						"typeText": "企业资讯",
						"num": 13,
						"isRead": 0
					},
					{
						"id": 23050,
						"date": "2023-08-09",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 12,
						"isRead": 0
					},
					{
						"id": 23356,
						"date": "2023-08-09",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 111,
						"isRead": 0
					},
					{
						"id": 23097,
						"date": "2023-08-09",
						"type": 5,
						"typeText": "企业资讯",
						"num": 15,
						"isRead": 0
					},
					{
						"id": 22849,
						"date": "2023-08-08",
						"type": 1,
						"typeText": "投资项目动态",
						"num": 16,
						"isRead": 0
					},
					{
						"id": 23357,
						"date": "2023-08-08",
						"type": 2,
						"typeText": "拿地项目动态",
						"num": 161,
						"isRead": 0
					},
					{
						"id": 22850,
						"date": "2023-08-08",
						"type": 4,
						"typeText": "招商情报实时动态",
						"num": 3,
						"isRead": 0
					}
				],
				dynamicurl: ["/investdynamic", "/landdynamic", "/enterpriseNews1", "/timeinfor", "/enterpriseNews", ],
				newsList: {title:''},
			}
		},
		props: {
			showVideo: {
				required: false,
				default: false,
			},
			videoType: {
				required: false,
				default: 4,
			},
		},
		watch: {
			curindex: {
				handler(newValue, oldValue) {
					this.type = newValue;
					$('.headr-nav-li').eq(this.curindex).addClass('current').siblings('.headr-nav-li').removeClass(
						'current');
				}
			},
		},
		created() {
			// this.userdata = this.getuseriformation();
		},
		mounted() {
			// // this.getuserinfor();  
			// if (this.userdata) {
			// 	this.getdynamicNotify();
			// 	this.getUserMessage();
			// } else {
			// 	this.userdata = this.getuseriformation();
			// 	this.getdynamicNotify();
			// 	this.getUserMessage();
			// }
		},
		methods: {
			...mapMutations({
				set_collapse: "SET_COLLAPSE"
			}),
			handerChrend(falg) {
			this.isShowShiyong = falg;

			},
			
			//跳转外部页面，正式版的产业研究大脑
			yjLoginPage(url){
				window.open(url);
			},
			//折叠菜单
			onClickfoldBtn() {
				console.log('点击展开收起',this.isCollapse)
				this.set_collapse(!this.isCollapse)
			},
			//动态消息展示
			getUserMessage() {
				var that = this;
				this.$axios.get(this.$api.cyl.userMessage.latest(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('动态消息展示govhearder',res); 
					if (res.data.success) {
						that.newsList = res.data.data||{title:''};
						// that.newsList=res.data.list;
					}
				})
			},
			//动态监测实时滚动
			dynamicTimer() {
				// console.log(this.$refs.list.offsetWidth,this.dynamicWidth);
				this.timerClock = setInterval(() => {
					if (this.timeClockBtn) {
						let newPosition = this.dynamicMovepostion - 1;
						if (newPosition < -(this.dynamicWidth - 100)) {
							newPosition = 0;
						}
						this.dynamicMovepostion = newPosition;
					}
				}, 50);
			},
			// getuserinfor(){
			// 	let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
			// 	if(typeof(dataddd) == 'object'){
			// 	this.userdata = dataddd;
			// 	}else{
			// 	this.userdata = JSON.parse(dataddd);
			// 	}  ;
			// 	console.log('voheader.this.userdata',this.userdata)
			// 	if(this.userdata.token && this.userdata.token.length>0){
			// 		this.getdynamicNotify();  
			// 	}else{
			// 		console.log('token拿不到',this.userdata);
			// 	}

			// },
			//获取动态监测列表
			getdynamicNotify() {
				var _this = this;
				// console.log('this.userdata.token',this.userdata.token);
				return;
				this.$axios.get(this.$api.cyl.dynamicNotify.list(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('获取动态监测实时列表a',res.data);
					if (res.data.success) {
						_this.ischange = res.data.data.isChange;
						var listg = res.data.list;
						var urlbox = [{
									type: 1,
									title: '投资项目动态',
									url: '/investdynamic'
								},
								{
									type: 2,
									title: '拿地项目动态',
									url: "/landdynamic",
								},
								{
									type: 3,
									title: "企业投资动态",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '招商情报动态',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '企业资讯动态',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '融资项目动态',
									url: "/financingdynamic",
								},
								{
									type: 7,
									title: '产业资讯动态',
									url: "/industryInvestment",
								},
							],
							smlist = [];
						if (_this.curWebsite.type == 4) {
							urlbox = [{
									type: 1,
									title: '投资项目动态',
									url: '/investdynamic'
								},
								{
									type: 2,
									title: '拿地项目动态',
									url: "/landdynamic",
								},
								{
									type: 3,
									title: "企业投资动态",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '市场情报动态',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '融资项目动态',
									url: "/financingdynamic",
								},
							]
						} else if (_this.curWebsite.type == 6 || _this.curWebsite.type == 5) {
							urlbox = [{
									type: 1,
									title: '上市公司投资动态',
									url: '/markenterprise'
								},
								{
									type: 2,
									title: '企业拿地投资动态',
									url: "/landenterprise",
								},
								{
									type: 3,
									title: "",
									url: "/enterpriseNews1",
								},
								{
									type: 4,
									title: '',
									url: "/timeinfor",
								},
								{
									type: 5,
									title: '',
									url: "/enterpriseNews",
								},
								{
									type: 6,
									title: '',
									url: "/financingdynamic",
								},
								{
									type: 7,
									title: '产业资讯动态',
									url: "/industryInvestment",
								},
							]
						}
						var datelist = [{
							date: listg[0].date,
							children: []
						}];
						var width1 = 96,
							width2 = 0,
							width3 = 0;
						for (var i = 0; i < listg.length; i++) {
							width2 += 152;
							var l = datelist.length - 1;
							var x = listg[i].type - 1;
							listg[i].urls = urlbox[x].url;
							listg[i].title = urlbox[x].title;
							if (listg[i].date == datelist[l].date) {
								datelist[l].children.push(listg[i]);
							} else {
								width1 += 96;
								datelist.push({
									date: listg[i].date,
									children: [listg[i]]
								});
							}
						}
						width3 = width1 + width2 - 40;
						_this.dynamicWidth = width3;
						// console.log('datelist',datelist);
						_this.dynamicListnum = datelist;
						if (datelist.length > 0) {
							_this.dynamicTimer();
						}

					} else {

					}
				}).catch(function(error) {
					// 请求失败处理
					// console.log(error);
				});
			},
			//点击取消阅读 跳转页面
			trunDynamicUrl(urls) {
				var _this = this;
				this.$axios.get(this.$api.cyl.dynamicNotify.read(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log("crm",res);
					if (res.data.success) {
						_this.routerself(urls);
					} else {

					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			}
		},
	}
</script>

<style lang="scss">
	/* @import url("../../css/entercss.css");  */
	@import url("../../css/headfoot.css");
	.gov_headerbox{
		.content-us{
		color: rgb(10, 112, 207);
		&:hover{
			opacity: .7;
			}
		}
	.orgfont{
			&:hover{
				opacity: .7;
			}
		}
	}
	
	
</style>